export default {
    namespaced: true,

    state: {
        all_cases: {},
        case_selected: {},
    },

    mutations:{
        set_all_cases(state, new_all_cases) {
            state.all_cases = new_all_cases
        },

        set_case_selected(state, new_case_selected) {
            state.case_selected = new_case_selected;
        },
    },

    actions: {          
        
    },

    getters: {
        is_case_mode(state) {
            return Object.keys(state.case_selected).length
        }
    },

}